<div class="row">
  <div class="col-sm-12 col-md-4 mb-2" *ngIf="type==2 ||type==1">
    <a routerLink="/drivers">

    <div class="card home">
      <div class="">
        <div class="row">
          <div class="col-md-12">
            <img src="../../assets/images/icons/userIconLg.svg"/>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <h4 class="primary-color">إدارة السائقين</h4>
          </div>
        </div>

      </div>
    </div>
    </a>
  </div>
  <div class="col-sm-12 col-md-4" *ngIf="type==2 ||type==1">
    <a routerLink="/bus">

    <div class="card home">
      <div class="">
        <div class="row">
          <div class="col-md-12">
            <img src="../../assets/images/icons/busIconLg.svg"/>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <h4 class="primary-color">إدارة الحافلات</h4>
          </div>
        </div>

      </div>
    </div>
    </a>
  </div>
  <div class="col-sm-12 col-md-4" *ngIf="type==2 ||type==1">
    <a routerLink="/mange-travel">

    <div class="card home">
      <div class="">
        <div class="row">
          <div class="col-md-12">
            <img src="../../assets/images/icons/schudleLg.svg"/>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <h4 class="primary-color">إدارة الرحلات </h4>
          </div>
        </div>

      </div>
    </div>
    </a>
  </div>


  <div class="col-sm-12 col-md-4 mb-2" *ngIf="type==2 ||type==1">
    <a routerLink="/tracking">

      <div class="card home">
        <div class="">
          <div class="row">
            <div class="col-md-12">
              <img src="../../assets/images/icons/busFrontLg.svg"/>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <h4 class="primary-color">تتبع الحافلات</h4>
            </div>
          </div>

        </div>
      </div>
    </a>

  </div>

  <!--  <div class="col-sm-12 col-md-4">-->
<!--    <a routerLink="/test">-->

<!--    <div class="card home">-->
<!--      <div class="">-->
<!--        <div class="row">-->
<!--          <div class="col-md-12">-->
<!--            <img src="../../assets/images/icons/chatLg.svg"/>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="row">-->
<!--          <div class="col-md-12">-->
<!--            <h4 class="primary-color">المحادثات</h4>-->
<!--          </div>-->
<!--        </div>-->

<!--      </div>-->
<!--    </div>-->

<!--    </a>-->
<!--  </div>-->
  <div class="col-sm-12 col-md-4" *ngIf="type==3 ||type==1">
    <a routerLink="/all-news">

    <div class="card home">
      <div class="" >
        <div class="row">
          <div class="col-md-12">
            <img src="../../assets/images/icons/newsLg.svg"/>
          </div>
        </div>
        <div class="row" >
          <div class="col-md-12">
            <h4 class="primary-color">بث الأخبار</h4>
          </div>
        </div>

      </div>
    </div>
    </a>

  </div>
  <div class="col-sm-12 col-md-4" *ngIf="type==2 ||type==1">
    <a routerLink="/subscription">
    <div class="card home">
      <div class="">
        <div class="row">
          <div class="col-md-12">
            <img src="../../assets/images/icons/subscriptionLg.svg"/>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <h4 class="primary-color">إدارة الاشتراكات</h4>
          </div>
        </div>

      </div>
    </div>
    </a>
  </div>

  <div class="col-sm-12 col-md-4" *ngIf="type==2 ||type==1">
    <a routerLink="/trip-line">

      <div class="card home">
        <div class="">
          <div class="row">
            <div class="col-md-12">
              <img src="../../assets/images/icons/lineLg.svg"/>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <h4 class="primary-color">إدارة خطوط النقل</h4>
            </div>
          </div>

        </div>
      </div>
    </a>
  </div>

  <div class="col-sm-12 col-md-4" *ngIf="type==2 ||type==1">
    <a routerLink="/test">
      <div class="card home">
        <div class="">
          <div class="row">
            <div class="col-md-12">
              <img src="../../assets/images/icons/reportsLg.svg"/>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <h4 class="primary-color">التقارير</h4>
            </div>
          </div>

        </div>
      </div>

    </a>
  </div>
<!--  <div class="col-sm-12 col-md-4">-->
<!--    <a routerLink="/test">-->

<!--    <div class="card home">-->
<!--      <div class="">-->
<!--        <div class="row">-->
<!--          <div class="col-md-12">-->
<!--            <img src="../../assets/images/icons/issueLg.svg"/>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="row">-->
<!--          <div class="col-md-12">-->
<!--            <h4 class="primary-color">الشكاوى</h4>-->
<!--          </div>-->
<!--        </div>-->

<!--      </div>-->
<!--    </div>-->
<!--    </a>-->
<!--  </div>-->
  <div class="col-sm-12 col-md-4" *ngIf="type==1">
    <a routerLink="/settings">

    <div class="card home">
      <div class="">
        <div class="row">
          <div class="col-md-12">
            <img src="../../assets/images/icons/cogLg.svg"/>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <h4 class="primary-color">الإعدادات</h4>
          </div>
        </div>

      </div>
    </div>
    </a>
  </div>


